import React, { Component, useState } from 'react';
import { Route,Switch } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import Quote from './components/Quote';
import ProposalForm from './components/ProposalForm';
import { SharedDataProvider } from './components/SharedDataContext';
import Summary from './components/Summary';
import Status from './components/Status';
import { useEffect } from 'react';
import axios from 'axios';
import { NavMenu } from './components/NavMenu';
import "./components/css/Header.css"
import WhatsAppBot from './components/whatsappbot/WhatsAppBot';

const App = () => {
    const [IsHideDash, setDeshBoard] = useState(true);
    const [UserData, setUserData] = useState("");
    const [cookies, setCookies] = useState();
    const [showWhatsAppBot, setWhatsAppBot] = useState(false);

    useEffect(() => {
        const allCookies = getCookies();
        if (allCookies.priviledge) {
            try {
                const obj = JSON.parse(atob(allCookies.priviledge));
                setCookies(obj);
            } catch (error) {
                console.error('Error decoding privilege cookie', error);
            }
        }

        const token = window.localStorage.getItem("token");
        if (token) {
            const parseToken = token.charAt(0) === "{";
            const data = {
                Token: parseToken ? JSON.parse(token).token : token,
            };

            const md = {
                URL: "GetUserInfo",
                PostString: JSON.stringify(data),
            };

            axios.post("/central/centralcall/CallReqWithHeader", md)
                .then((res) => {
                    if (res.data.userID !== "Session is abort") {
                        //dispatch(setUserData(res?.data));
                        setUserData(res?.data);
                        setDeshBoard(!(res.data.roleID === 29 || res.data.roleID === 32));

                        if (res.data.userID > 0) {
                            window.sessionStorage.setItem("UserID", res.data.userID);
                        }
                    } else {
                        setWhatsAppBot(true);
                        window.localStorage.removeItem("token");
                    }
                });
        } else {
            setWhatsAppBot(true);
        }

        //console.log(UserData, "User Data");
    }, []);

    useEffect(() => {
        console.log(cookies, "cookies Data 2 (after state update)");
    }, [cookies]);
    const getCookies = () => {
        var cookies = document.cookie.split(';');
        var cookieMap = {};
        cookies.forEach(function (cookie) {
            var parts = cookie.split('=');
            var name = parts[0].trim();
            var value = decodeURIComponent(parts[1]);
            cookieMap[name] = value;
        });
        return cookieMap;
    };
    //useEffect(() => {
    //    if (cookies) {
    //        const hasBlockPos = cookies?.priviledgeList.some(
    //            (item) => item.PrivilegeName.toLowerCase() === "become a pos"
    //        );
    //        //console.log(hasBlockPos, "Affiliate"); // Output will be true or false
    //        setBlockPos(hasBlockPos);
    //    } else {
    //        console.log("priviledgeList is not an array or cookies is undefined");
    //    }
    //}, [cookies]);

    useEffect(() => {
        if (UserData.userID === 188452) {
            document.documentElement.style.setProperty('--Prim-Color', "#5430bb");
            document.documentElement.style.setProperty('--LightBG', "#f1f7ff");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#3c17a5");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--AllImages', "grayscale(1)");
            document.documentElement.style.setProperty('--BTN-Radius', "10px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Roboto', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
        } else if (UserData.userID === 29502) {
            document.documentElement.style.setProperty('--Prim-Color', "#3F4599");
            document.documentElement.style.setProperty('--PrimeTextColor', "#161719");
            document.documentElement.style.setProperty('--SecondryTextColor', "#5F6570");
            document.documentElement.style.setProperty('--LightBG', "#eef1fabd");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#30368e");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--BTN-Radius', "5px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Poppins', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
            document.documentElement.style.setProperty('--AllImagesColor1', "grayscale(1)");
            document.documentElement.style.setProperty('--ComnFontSize', "11px");
            document.documentElement.style.setProperty('--MiddFontSize', "14px");
        }
    }, [UserData]);
    return (
        <SharedDataProvider>
            <NavMenu CoockieData={cookies} Udata={UserData} />
            {showWhatsAppBot && <WhatsAppBot />}
          <Switch>
            <Route exact path={'/'} component={Home} />
            <Route exact path={'/quote'} component={Quote} />
            <Route exact path={'/proposal'} render={(props) => <ProposalForm {...props} />} />
            <Route exact path={'/summary'} render={(props) => <Summary {...props} />} />
            <Route path={'/status/:orderGUID'} component={Status} />
          </Switch>
      </SharedDataProvider>
    );
  }

export default App;
